/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {directDepositTransferSelection} from '../api'

export const useMutationDirectDepositTransferSelection = createReactQueryMutationHook('directDepositTransferSelection', directDepositTransferSelection)
